import { cva } from "class-variance-authority";
export { default as Badge } from "./Badge.vue";
export const badgeVariants = cva("tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-transition-colors", {
    variants: {
        variant: {
            default: "tw-border-transparent tw-bg-primary tw-text-white",
            secondary: "tw-border-transparent tw-bg-gray-600 tw-text-white",
            destructive: "tw-border-transparent tw-bg-error tw-text-white",
            success: "tw-border-transparent tw-bg-success tw-text-white",
            warning: "tw-border-transparent tw-bg-warning tw-text-white",
            info: "tw-border-transparent tw-bg-info tw-text-white",
            outline: "tw-text-foreground tw-border-border"
        }
    },
    defaultVariants: { variant: "default" }
});
